import { copilotAxiosInstance } from "./BaseService";

export async function sendCopilotMessage({ message, userId, tenantId }) {
  try {
    const response = await copilotAxiosInstance.post("/chat", { message, userId, tenantId });
    return response.data;
  } catch (err) {
    console.error("Erro no serviço do Copilot:", err);
    return {
      success: false,
      message: err.message,
    };
  }
}